import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/platform/authentication/hooks/useAuth';

export const PLATFORM_TENANT_ID = '20000000-0000-0000-0000-000000000003';

/**
 * Hides cross-tenant administration from ordinary tenant sessions. This is a
 * presentation boundary only: the API additionally requires the immutable
 * Entra platform-owner identity and fresh interactive MFA on every request.
 */
export function TenantAdministrationAccessGuard({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  if (user?.tenantId !== PLATFORM_TENANT_ID) {
    return <Navigate to="/switchboard" replace />;
  }

  return children;
}
